import { useEffect, useState } from "react";
import axios from "axios";
import { PATHS_API } from "../../enum";
import { useUserStore } from "../../modules/shop/user/store";

// Перевіряє, чи є у поточного користувача хоча б один особистий товар (сет)
export const useHasPersonalProducts = () => {
    const user = useUserStore((state) => state.user);
    const [hasPersonalProducts, setHasPersonalProducts] = useState(false);

    useEffect(() => {
        if (!user?.steamId) {
            setHasPersonalProducts(false);
            return;
        }

        let cancelled = false;

        axios.get(PATHS_API.PERSONAL, { withCredentials: true })
            .then(({ data }) => {
                if (!cancelled) {
                    setHasPersonalProducts(Array.isArray(data) && data.length > 0);
                }
            })
            .catch((error) => {
                if (!cancelled) {
                    setHasPersonalProducts(false);
                }
                console.error("Помилка під час перевірки особистих товарів:", error);
            });

        return () => {
            cancelled = true;
        };
    }, [user?.steamId]);

    return hasPersonalProducts;
};
